import { TEMPORARY_MESSAGE_PREFIX } from "../constants";
import { connectedAsUser, messagesByChannelId } from "../state";

function flattenReactions({
  reaction_counts: reactionCounts,
  own_reactions: ownReactions,
  latest_reactions: latestReactions,
}) {
  const myReactionIdMap = new Map();
  (ownReactions || []).forEach((reaction) => {
    myReactionIdMap.set(reaction.type, true);
  });

  const { id: myId } = connectedAsUser.get();

  return Object.keys(reactionCounts || {}).map((reactionId) => ({
    id: reactionId,
    count: reactionCounts[reactionId],
    byMe: myReactionIdMap.has(reactionId),
    latestNames: latestReactions.reduce((accum, reaction) => {
      // keep own name out of latest names. clients will use the byMe prop to append/prepend "You" to latest names for tool tip
      if (reaction.type === reactionId && reaction.user.id !== myId) {
        accum.push(reaction.user.name);
      }
      return accum;
    }, []),
  }));
}

export function flattenRawMessage(rawMessage) {
  const { type, id, user, text, created_at: createdAtObjOrString } = rawMessage;
  // messages that come in via events are flattened while messages that are queried for are objects
  const createdAt = new Date(createdAtObjOrString);
  const reactions = flattenReactions(rawMessage);

  return {
    type,
    messageId: id,
    markdown: text,
    userId: user.id,
    createdAt,
    reactions,
  };
}

// this is slow maybe revisit
export function updateMessage(channelId, flattenedMessage) {
  const messagesObj = messagesByChannelId.get();
  const messages = messagesObj[channelId];
  const index = messages.findIndex(
    (m) => m.messageId === flattenedMessage.messageId
  );

  messagesByChannelId.set((obj) => ({
    ...obj,
    [channelId]: [
      ...messages.slice(0, index),
      flattenedMessage,
      ...messages.slice(index + 1),
    ],
  }));
}

export function appendChannelMessage(channelId, message) {
  messagesByChannelId.set((obj) => {
    const messages = obj[channelId] || [];
    // filter out any messages that start with the temporary prefix and contain the same markdown
    const newMessages = [...messages].filter((m) => {
      const isTemporaryMessage = m.messageId.startsWith(
        TEMPORARY_MESSAGE_PREFIX
      );
      const hasSameContent = m.markdown === message.markdown;
      // this seemed easier to reason about this by creating the filter condition and negating it
      return !(isTemporaryMessage && hasSameContent);
    });
    return {
      ...obj,
      [channelId]: [...newMessages, message],
    };
  });
}

export function prependChannelMessages(channelId, messages) {
  messagesByChannelId.set((obj) => ({
    ...obj,
    [channelId]: [...messages, ...(obj[channelId] || [])],
  }));
}
